import type { FC, PropsWithChildren } from "react";

import classnames from "classnames";

import styles from "./Container.module.scss";

export type ContainerProps = {
  className?: string;
  dataTestId?: string;
};

export const Container: FC<PropsWithChildren<ContainerProps>> = ({ children, className, dataTestId }) => {
  return (
    <div data-testid={dataTestId || "container"} className={classnames(styles.container, className)}>
      {children}
    </div>
  );
};
